import { Link } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import { playercards } from "../../helper/constant";

const SearchCards = () => {
  return (
    <div className="w-full mx-auto mt-5">
      <h3 className="text-lg font-semibold mb-4">I am looking for</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {playercards.map((card) => (
          <Link
            to={card.route}
            key={card.id}
            className="bg-white rounded-2xl shadow-md overflow-hidden p-2 hover:shadow-lg transition"
          >
            <img
              src={card.image}
              alt={card.title}
              className="w-full h-44 rounded-xl object-cover"
            />
            <div className="flex justify-between items-center p-3">
              <div>
                <p className="text-sm font-medium">{card.title}</p>
                <p className="text-xs">{card.description}</p>
              </div>
              <GoArrowRight className="w-6 h-6 bg-gray-100 p-1 rounded-sm" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SearchCards;
